import { AlertProps } from '@chakra-ui/react';

export const betRecoveryAlertProps: AlertProps = {
  color: 'delta.500',
};
